export default "__VITE_ASSET__byzRkvRe__"